import 'bootstrap-datepicker'
const [w] = [window]

export default function ENTRYFORM () {

  const init = () =>{

  $( '.row-ymd input[type=text]' ).datepicker({
      forceParse: false
    }).on( 'changeDate', function( e ) {
      $( '.w-year'  ).val( e.date.getFullYear() );
      $( '.w-month' ).val( e.date.getMonth() + 1 );
      $( '.w-day'   ).val( e.date.getDate() );
  });

  }

  w.addEventListener('DOMContentLoaded',init)

}